export default __webpack_public_path__ + "static/media/Global_Communities.b82ce7d2.png";